module.exports = __webpack_public_path__ + "img/mail-ft.6bf8a961.png";